<template>
  <slot />
</template>

<script lang="ts">
export default {
  name: 'LayoutEmpty',
}
</script>
